export const ShowcaseItem = ({ j }: { j: number }) => {
  const imgPath = `/sp/${j}.png`;
  return <img className="showcase-img" alt="silhouette" src={imgPath} />;
};
